import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
    deleteDocument,
    generateCustomID,
    saveData,
    uniqueID,
    uploadImage,
} from "../../../firebase/utility";
import { fetchMfgUtil } from "../../../utility";
const useManufacturerHook = () => {
    const dispatch = useDispatch();
    const { all_manufacturers } = useSelector((state) => state.redux);
    const [page, setPage] = useState(() => {
        const p = parseInt(localStorage.getItem("manufacturerPage"), 10);
        return !isNaN(p) ? p : 1;
    });
    const [pageSize, setPageSize] = useState(50);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [totalPages, setTotalPages] = useState(0);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modal, setModal] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null);
    const [search, setSearch] = useState("");
    const [selectedMfg, setSelectedMfg] = useState(null);
    const gettingManufacturers = () => {
        if (search?.length > 1) {
            localStorage.setItem("manufacturerPage", 1)
            setPage(1)
        }
        fetchMfgUtil({
            page,
            search: search,
            pageSize,
            setLoading,
            dispatch,
            setTotalPages,
        });
    }
    const handleDelete = () => {
        if (selectedMfg) {
            deleteDocument("Manufacturers", selectedMfg?._id).then((res) => {
                toast.success(`Manufacturer ${selectedMfg?.name} deleted Successfully`);
                gettingManufacturers();
                setSelectedMfg(null);
            });
        }
    };
    const handleSubmitData = async (obj, file, setData, logoFile) => {

        setSubmitLoading(true);
        let data = {
            _id: obj?._id ?? uniqueID(),
            ...obj,
            createdAt: obj?.createdAt ?? Date.parse(new Date()),
            id: obj?.id ?? (await generateCustomID("Manufacturers", "id")),
        };
        let losFile;
        if (file != undefined && typeof file === "object") {
            losFile = await uploadImage(file, "manufacturers");
            if (losFile) {
                data.loaLos = losFile;
            }
        } else {
            data.loaLos = false;
        }

        if (logoFile != undefined && typeof logoFile === "object") {
            let uploadedLogo = await uploadImage(logoFile, "manufacturers");
            if (uploadedLogo) {
                data.logo = uploadedLogo;
            }
        }

        saveData("Manufacturers", data?._id, data).then((res) => {
            if (res) {
                toast.success(`Manufacturer ${data?.name} Saved Successfully`);
                gettingManufacturers()
                setData(null);
                setModal(false);
                setSubmitLoading(false);
            }
        });
    };
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            gettingManufacturers()
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [page, search, pageSize]);
    useEffect(() => {
        let search = localStorage.getItem('mfgSearch')
        setSearch(search)
    }, [])
    return {
        page,
        setPage,
        pageSize,
        setPageSize,
        totalPages,
        loading,
        setDeleteModal,
        deleteModal,
        handleDelete,
        modal,
        setModal,
        handleSubmitData,
        selectedObj,
        manufacturers: all_manufacturers || [],
        search,
        setSearch,
        setSelectedMfg,
        setSelectedObj,
        submitLoading
    };
};
export default useManufacturerHook;
